import type { FaireProductEntity } from "../../entity_types/product";

export const p_bexjxt92v3: FaireProductEntity = {
  token: "p_bexjxt92v3",
  type: "product",
  name: "Coconut Bowl Mother of Pearl Inlay - LVH36",
  brandName: "World Buyers",
  imageUrl:
    "https://cdn.faire.com/fastly/a0d37ed7af6b28718ac44df0c5c0025a849f91c836b0b8d941d2f9905c3df84b.jpeg",
  priceDollars: 7.75,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/0ba681d77ebac758368747c384944bda421ac31a4cf8e9343c91219dc50ef5d5.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
